exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RatingStars .star:not(.disabled) {\n  cursor: pointer;\n}\n.RatingStars .star.\\--full,\n.RatingStars .star.\\--half {\n  --text-opacity: 1;\n  color: #ecc94b;\n  color: rgba(236, 201, 75, var(--text-opacity));\n  /*color: #ffd147;*/\n}\n.RatingStars .star.\\--empty {\n  --text-opacity: 1;\n  color: #cbd5e0;\n  color: rgba(203, 213, 224, var(--text-opacity));\n  /*color: gray;*/\n}\n", ""]);

// exports
